module.exports = __webpack_public_path__ + "static/media/banner-banker-img.db06778c.png";